import {
  integrationSyncHistoryService,
  ListIntegrationSyncRunsRequest,
} from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

const useFetchIntegrationSyncRuns = (params: ListIntegrationSyncRunsRequest, enabled = true) => {
  return useQuery({
    queryKey: ['fetchIntegrationSyncRuns', params],
    queryFn: () => integrationSyncHistoryService.getRuns(params),
    enabled,
  });
};

export default useFetchIntegrationSyncRuns;
